const options = {
  5: "bg-emerald-900/5",
  10: "bg-emerald-900/10",
  25: "bg-emerald-900/25",
  50: "bg-emerald-900/50",
  75: "bg-emerald-900/75",
  90: "bg-emerald-900/90",
  100: "bg-emerald-900",
};

const from = {
  5: "from-emerald-900/5",
  10: "from-emerald-900/10",
  25: "from-emerald-900/25",
  50: "from-emerald-900/50",
  75: "from-emerald-900/75",
  90: "from-emerald-900/90",
  100: "from-emerald-900",
};

export default function getBackgroundEmerald900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
